import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useRecertificationDialogStore = defineStore('recertificationDialogStore', () => {
  const isOpen = ref(false)
  const storeResolve = ref<((value: string | PromiseLike<string>) => void) | null>(null)
  const storeReject = ref<((value: string | PromiseLike<string>) => void) | null>(null)
  const password = ref('')

  const openDialog = () => {
    isOpen.value = true
    return new Promise<string>((resolve, reject) => {
      storeResolve.value = resolve
      storeReject.value = reject
    })
  }

  const ok = () => {
    storeResolve.value?.(password.value)
  }
  const cancel = () => {
    storeReject.value?.('cancel')
    reset()
  }

  const reset = () => {
    isOpen.value = false
    storeResolve.value = null
    storeReject.value = null
    password.value = ''
  }

  return {
    isOpen,
    password,
    openDialog,
    ok,
    cancel,
    reset
  }
})
